export default function slugify(s: string): string {
  return `${s.trim().replace(/[^0-9a-z-]/gi, '-')}`.toLowerCase();
}
